import { dataCircleExtendSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCircleExtendSolid = /*#__PURE__*/createIcon(dataCircleExtendSolid)
export default IconCircleExtendSolid
